import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadingStatus = _resolveComponent("UploadingStatus")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    modelValue: _ctx.isShowPopup,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShowPopup) = $event)),
    title: "Статус загрузки файла",
    contentClass: "modal--new",
    width: 700,
    themeLigth: "",
    onClose: _ctx.closePopup
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UploadingStatus, { info: _ctx.info }, null, 8, ["info"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}